module.exports = __webpack_public_path__ + "static/media/question-icon.78baa913.svg";